export default {
  up: 'Up',
  user: 'User',
  users: 'Users',
  utc: 'UTC'
}
